<template>
  <div>
    <div class="docArea">
      <template v-if="version == 2 && !loginShow">
        <div class="line">
          <img src="@/assets/images/person/avater6.png" alt="" />
          <span>《中储智运平台服务协议》 </span>
          <el-button type="text" @click="showAgreement('serveAgreement')">
            查看 <i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </div>
        <div class="line">
          <img src="@/assets/images/person/avater6.png" alt="" />
          <span>《中储智运网络货运平台交易规则》 </span>
          <el-button type="text" @click="showAgreement('dealAgreement')">
            查看 <i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </div>
        <div class="line">
          <img src="@/assets/images/person/avater6.png" alt="" />
          <span>《用户授权协议》</span>
          <el-button type="text" @click="showAgreement('permissonAgreement')">
            查看 <i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </div>
        <div class="line">
          <img src="@/assets/images/person/avater6.png" alt="" />
          <span>《隐私政策》</span>
          <el-button type="text" @click="showAgreement('privacyAgreement')">
            查看 <i class="el-icon-arrow-right el-icon--right"></i
          ></el-button>
        </div>
      </template>
      <template v-else>
        <a style="color: #429bff" href="javascript:;" @click="showAgreement('serveAgreement')"
          >《中储智运平台服务协议》
        </a>
        <a style="color: #429bff" href="javascript:;" @click="showAgreement('dealAgreement')"
          >《中储智运网络货运平台交易规则》
        </a>
        <a style="color: #429bff" href="javascript:;" @click="showAgreement('permissonAgreement')">《用户授权协议》</a>
        <a style="color: #429bff" href="javascript:;" @click="showAgreement('privacyAgreement')">《隐私政策》</a>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" append-to-body width="1100px">
      <div style="height: 500px; padding: 20px; word-break: break-all; overflow-y: auto">
        <component :is="activeAgreement"></component>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import serveAgreement from '@/views/publicPage/login/register/serveAgreement.vue';
Vue.component('ServeAgreement', serveAgreement);
import dealAgreement from '@/views/publicPage/login/register/dealAgreement.vue';
Vue.component('DealAgreement', dealAgreement);
import permissonAgreement from '@/views/publicPage/login/register/permissonAgreement.vue';
Vue.component('PermissonAgreement', permissonAgreement);
import privacyAgreement from '@/views/publicPage/login/register/privacyAgreement.vue';
Vue.component('PrivacyAgreement', privacyAgreement);
import { mapMutations, mapState } from 'vuex';
export default {
  props: {
    loginShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogTitle: '',
      dialogVisible: false,
      activeAgreement: ''
    };
  },
  computed: {
    ...mapState('user', ['version'])
  },
  methods: {
    showAgreement(acitveName) {
      this.dialogVisible = true;
      this.activeAgreement = acitveName;
      switch (acitveName) {
        case 'serveAgreement':
          this.dialogTitle = '中储智运平台服务协议';
          break;
        case 'dealAgreement':
          this.dialogTitle = '中储智运网络货运平台交易规则';
          break;
        case 'permissonAgreement':
          this.dialogTitle = '用户授权协议';
          break;
        case 'privacyAgreement':
          this.dialogTitle = '隐私政策';
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.docArea {
  display: flex;
  flex-direction: column;
}
</style>
